import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Alert, Button, Col, Form, Modal, Row, Table } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { Heading } from '@lomarengas/design-system';
import Select from 'react-select';

import { useTranslation } from 'react-i18next';
import {
  BookingType,
  bookingTypeTranslations,
} from '../Constants/BookingTypeEnum';
import {
  addAddOnBookingToBookingContainerAsync,
  addAddOnToBookingContainerAsync,
  AddAddOnToBookingContainerItem,
  BookingContainer,
  BookingContainerUpdateItem,
  BookingDetailsData,
  BookingDetailsNoteItem,
  BookingDetailsOrderItem,
  ClearContainerAsync,
  ClearContainerItem,
  confirmBookingAsync,
  CreateBookingNote,
  getBookingContainerDetailsAsync,
  getSelectableAddOnsAsync,
  selectBasketBookingContainer,
  setBasketContainer,
  setWebShopCustomerState,
  updateBookingContainerAsync,
  UpdateBookingToPreliminary,
  UpdateBookingToPreliminaryAsync,
  WebShopCustomerItem,
} from '../bookingsSlice';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { BillingLocales } from '../Constants/BillingLocales';
import {
  AccountDetailsFromDb,
  getAcountDetailsFromDbAsync,
} from '../../Users/identityUsersSlice';
import { addStatusToast } from '../../../common/components';

export interface BooleanProps {
  showAdditionalBookingModal;
  setShowAdditionalBookingModal;
  editedBooking: BookingDetailsData;
  setEditedBooking;
  setBookingContainer;
  setBasketContainer;
  webshopCustomer;
  refresh;
  pastBooking: boolean;
}

export interface SelectableAddOnFilter {
  accommodationId: string;
  units: number;
  adults: number;
  childs: number;
  includeNonVisible: boolean;
}

export const AdditionalBookingModal: React.FC<BooleanProps> = ({
  showAdditionalBookingModal,
  setShowAdditionalBookingModal,
  editedBooking,
  setEditedBooking,
  setBookingContainer,
  webshopCustomer,
  refresh,
  pastBooking,
  ...props
}) => {
  const { t } = useTranslation(['common', 'travelAgencyBookingModal']);
  const textAreaRefs = useRef([]);
  const ownertextAreaRefs = useRef([]);
  const officertextAreaRefs = useRef([]);

  const history = useNavigate();
  const dispatch = useAppDispatch();
  const selectableAddOns = useAppSelector(
    state => state.bookings.selectableAddOns,
  );
  const basketContainer = useAppSelector(selectBasketBookingContainer);
  const initFetch = useCallback(() => {}, [dispatch]);

  const [editedBookingLocal, setEditedBookingLocal] =
    useState<BookingDetailsData>(editedBooking);
  const [editedCustomerBookingNotes, setEditedCustomerBookingNotes] = useState<
    BookingDetailsNoteItem[]
  >(
    editedBookingLocal !== null &&
      editedBookingLocal !== undefined &&
      editedBookingLocal.customerBookingNotes !== null &&
      editedBookingLocal.customerBookingNotes !== undefined
      ? editedBookingLocal.customerBookingNotes
      : [],
  );

  const [editedOwnerBookingNotes, setEditedOwnerBookingNotes] = useState<
    BookingDetailsNoteItem[]
  >(
    editedBookingLocal !== null &&
      editedBookingLocal !== undefined &&
      editedBookingLocal.ownerBookingNotes !== null &&
      editedBookingLocal.ownerBookingNotes !== undefined
      ? editedBookingLocal.ownerBookingNotes
      : [],
  );
  const [editedOfficerBookingNotes, setEditedOfficerBookingNotes] = useState<
    BookingDetailsNoteItem[]
  >(
    editedBookingLocal !== null &&
      editedBookingLocal !== undefined &&
      editedBookingLocal.officerBookingNotes !== null &&
      editedBookingLocal.officerBookingNotes !== undefined
      ? editedBookingLocal.officerBookingNotes
      : [],
  );
  const [linenChecked, setLinenChecked] = useState(false);
  const [cleaningChecked, setCleaningChecked] = useState(false);
  const [ownerOwnBookingType, setOwnerOwnBookingType] = useState('OwnerOwn');

  const [editedSelectableAddOns, seteditedSelectableAddOns] =
    useState<BookingDetailsOrderItem[]>(selectableAddOns);

  const [makingOwnerBooking, setMakingOwnerBooking] = useState<boolean>(false);

  const [selectedPayer, setSelectedPayer] =
    useState<AccountDetailsFromDb>(null);
  const initialBookingContainer: BookingContainer = {
    id: '',
    bookingContainerStatus: 0,
    bookingResponses: [],
    advancePaid: false,
    acceptMarketing: false,
    acceptCancelInsuranceTerms: false,
    acceptBookingTerms: false,
    siteId: '',
    adults: 0,
    childs: 0,
    containerTotal: 0,
    containerTravelTotal: 0,
  };
  function handleCloseBooking() {
    const clearCommand = {
      bookingContainerId: basketContainer.id,
    } as ClearContainerItem;
    dispatch(ClearContainerAsync(clearCommand)).then(() => {
      dispatch(setBasketContainer(initialBookingContainer));
    });
    setShowAdditionalBookingModal(false);
  }
  function handleCloseBookingOwner() {
    setShowAdditionalBookingModal(false);
  }
  function getGlobalEndDate() {
    if (
      editedBooking != null &&
      editedBooking.bookingOrderItems != null &&
      editedBooking.bookingOrderItems.length > 0 &&
      !pastBooking
    ) {
      const item = editedBooking.bookingOrderItems.filter(
        i => i.orderItemType === 0,
      );
      if (item != null && item.length > 0) {
        return item[0].endDateTime;
      }
    } else if (
      editedBooking != null &&
      editedBooking.bookingOrderItems != null &&
      editedBooking.bookingOrderItems.length > 0 &&
      pastBooking
    ) {
      const modifiedDateEnd = new Date();
      const item = editedBooking.bookingOrderItems.filter(
        i => i.orderItemType === 0,
      );
      if (item != null && item.length > 0) {
        const realEnd = item[0].endDateTime;
        const realStart = item[0].startDateTime;
        if (realEnd != null && realStart != null) {
          const newModifiedDateEnd = new Date();
          newModifiedDateEnd.setDate(newModifiedDateEnd.getDate() + 1);
          newModifiedDateEnd.setHours(
            new Date(realEnd).getHours(),
            new Date(realEnd).getMinutes(),
          );
          return newModifiedDateEnd?.toISOString();
        }
        modifiedDateEnd.setHours(
          new Date(realEnd).getHours(),
          new Date(realEnd).getMinutes(),
        );
        return modifiedDateEnd.toISOString();
      }
    }
    return '';
  }
  function getGlobalStartDate() {
    if (
      editedBooking != null &&
      editedBooking.bookingOrderItems != null &&
      editedBooking.bookingOrderItems.length > 0 &&
      !pastBooking
    ) {
      const item = editedBooking.bookingOrderItems.filter(
        i => i.orderItemType === 0,
      );
      if (item != null && item.length > 0) {
        return item[0].startDateTime;
      }
    } else if (
      editedBooking != null &&
      editedBooking.bookingOrderItems != null &&
      editedBooking.bookingOrderItems.length > 0 &&
      pastBooking
    ) {
      const modifiedDate = new Date();
      modifiedDate.setHours(16, 0);
      return modifiedDate.toISOString();
    }

    return '';
  }
  const handleAddToBookingContainer = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const addedItem = editedSelectableAddOns[index];
    const tempContainer = {
      ...basketContainer,
    };
    const addAccommodationItem: AddAddOnToBookingContainerItem = {
      accommodationId: addedItem.accommodationId,
      accommodationAddOnId: addedItem.addOnId,
      bookingId: editedBooking.id,
      units: addedItem.units,
      sitePurchasePrice: addedItem.purchasePricesResponse.sitePurchasePrice,
      arrivalDateTime: getGlobalStartDate(),
      departureDateTime: getGlobalEndDate(),
      adults: addedItem.amountOfAdults,
      childs: addedItem.amountOfChildren,
      finalBillNetPrice: addedItem.pricesResponse.finalBillNetPrice,
      finalBillPrice: addedItem.pricesResponse.finalBillPrice,
      grossPrice: addedItem.pricesResponse.grossPrice,
      netPrice: addedItem.pricesResponse.netPrice,
      purchasePrice: addedItem.purchasePricesResponse.ownerPurchasePrice,
      bookingContainerId: tempContainer.id,
      advanceBillGrossPrice: addedItem.pricesResponse.advanceBillPrice,
      vatPerCent: addedItem.pricesResponse.vatP,
    } as AddAddOnToBookingContainerItem;
    dispatch(addAddOnBookingToBookingContainerAsync(addAccommodationItem))
      .then(res => {
        if (res.payload.isSuccess) {
          dispatch(setBasketContainer(res.payload.result)).then(res2 => {});
        }
      })
      .catch(err => {
        console.error('error happened in addind accommodation:', err);
      });
  };
  function updateBookingContainerWithData(newBooking, value) {
    if (editedBookingLocal === null) {
      return;
    }
    const container = {
      bookingContainerId: editedBookingLocal.bookingContainerId ?? '',
      bookingContainerStatus: 0,
      bookings: [newBooking],
      acceptBookingTerms: false,
      acceptCancelInsuranceTerms: false,
      acceptMarketing: false,
    } as BookingContainerUpdateItem;
    if (editedBookingLocal !== null) {
      dispatch(updateBookingContainerAsync(container)).then(res => {
        if (res.payload.isSuccess === true) {
          const findItem = res.payload.result.bookingResponses.filter(
            i => i.id === editedBooking.id,
          );
          if (findItem != null && findItem.length > 0) {
            const tempBookingTypeData2 = {
              ...findItem[0],
              bookingType: value,
            };
            setEditedBooking(tempBookingTypeData2);
            setEditedBookingLocal(tempBookingTypeData2);
          }
        } else {
          const findItem = res.payload.result.bookingResponses.filter(
            i => i.id === editedBooking.id,
          );
          console.debug(
            'Error updating booking container',
            res.payload.result.errors,
          );
          if (findItem != null && findItem.length > 0) {
            setEditedBookingLocal(findItem[0]);
            dispatch(setBookingContainer(res.payload.result));
          }
          dispatch(
            addStatusToast({
              Message:
                t(
                  `travelAgencyBookingModal:validation:errors.${
                    res.payload.result.errors[0]
                  }`,
                ) ?? t('travelAgencyBookingModal:validation:errors.Virhe'),
              IsFailed: true,
              Title: 'Virhe',
            }),
          );
        }
      });
    }
  }
  function updateBookingContainer() {
    if (editedBookingLocal === null) {
      return;
    }
    const container = {
      bookingContainerId: editedBookingLocal.bookingContainerId ?? '',
      bookingContainerStatus: 0,
      bookings: [editedBookingLocal],
      acceptBookingTerms: false,
      acceptCancelInsuranceTerms: false,
      acceptMarketing: false,
    } as BookingContainerUpdateItem;
    if (editedBookingLocal !== null) {
      dispatch(updateBookingContainerAsync(container)).then(res => {
        if (res.payload.isSuccess === true) {
          const findItem = res.payload.result.bookingResponses.filter(
            i => i.id === editedBooking.id,
          );
          if (findItem != null && findItem.length > 0) {
            setEditedBookingLocal(findItem[0]);
            setEditedBooking(findItem[0]);
            dispatch(setBookingContainer(res.payload.result));
          }
        } else {
          const findItem = res.payload.result.bookingResponses.filter(
            i => i.id === editedBooking.id,
          );
          console.debug(
            'Error updating booking container',
            res.payload.result.errors,
          );
          if (findItem != null && findItem.length > 0) {
            setEditedBookingLocal(findItem[0]);
            setEditedBooking(findItem[0]);
            dispatch(setBookingContainer(res.payload.result));
          }
          dispatch(
            addStatusToast({
              Message:
                t(
                  `travelAgencyBookingModal:validation:errors.${
                    res.payload.result.errors[0]
                  }`,
                ) ?? t('travelAgencyBookingModal:validation:errors.Virhe'),
              IsFailed: true,
              Title: 'Virhe',
            }),
          );
        }
      });
    }
  }

  function localSetEditedBooking(booking) {
    setEditedBookingLocal(booking);
  }
  function confirmBooking() {
    if (editedBookingLocal !== null) {
      dispatch(setWebShopCustomerState(null));
      dispatch(confirmBookingAsync(editedBookingLocal))
        .then(res => {
          if (res.payload.isSuccess !== true) {
            if (res.payload.isSuccess === false) {
              if (res.payload.message != null) {
                dispatch(
                  addStatusToast({
                    Message: res.payload.message,
                    IsFailed: true,
                    Title: 'Virhe',
                  }),
                );
              }
              if (
                res.payload.result != null &&
                res.payload.result.errors != null &&
                res.payload.result.errors.length > 0
              ) {
                res.payload.result.errors.map(error => {
                  return dispatch(
                    addStatusToast({
                      Message: error,
                      IsFailed: true,
                      Title: 'Virhe',
                      DelayMs: 10000,
                      IsAutohide: false,
                    }),
                  );
                });
              }
            } else if (
              res.payload.errorCode !== null &&
              res.payload.Message !== null
            ) {
              // dispatch(
              //   addStatusToast({
              //     Message: res.payload.Message,
              //     IsFailed: true,
              //     Title: 'Virhe',
              //   }),
              // );
            }
          } else {
            const findItem = res.payload.result.bookingResponses.filter(
              i => i.id === editedBooking.id,
            );
            if (findItem != null && findItem.length > 0) {
              setEditedBookingLocal(findItem[0]);
              setEditedBooking(findItem[0]);
              dispatch(getBookingContainerDetailsAsync(findItem[0].id));
              dispatch(setBasketContainer(initialBookingContainer)).then(() => {
                history(`/bookings/${findItem[0].id}`, {
                  state: {
                    id: res.payload.result.id,
                    from: window.location.pathname,
                  },
                });
                handleCloseBooking();
              });
            }
          }
        })
        .catch(err => {
          dispatch(
            addStatusToast({
              Message: 'Virhe varauksen vahvistamisessa',
              IsFailed: true,
              Title: 'Virhe',
            }),
          );
        });
    }
  }
  useEffect(() => {
    initFetch();
  }, [initFetch]);

  useEffect(() => {
    if (
      selectableAddOns !== null &&
      selectableAddOns.length > 0 &&
      editedBooking != null
    ) {
      const accommodationItem = editedBooking.bookingOrderItems?.find(
        i => i.orderItemType === 0,
      );
      if (accommodationItem) {
        const updatedSelectableAddOns = selectableAddOns.map(addOn => ({
          ...addOn,
          amountOfAdults: accommodationItem.amountOfAdults,
          amountOfChildren: accommodationItem.amountOfChildren,
          amountPerGuest: addOn.amountPerGuest,
          amountPerQuantity: addOn.amountPerQuantity,
        }));
        seteditedSelectableAddOns(updatedSelectableAddOns);
      }
    }
  }, [selectableAddOns, editedBooking]);

  useEffect(() => {
    if (editedBookingLocal) {
      if (editedBookingLocal.customerBookingNotes) {
        setEditedCustomerBookingNotes(editedBookingLocal.customerBookingNotes);
      }
      if (editedBookingLocal.ownerBookingNotes) {
        setEditedOwnerBookingNotes(editedBookingLocal.ownerBookingNotes);
      }
      if (editedBookingLocal.officerBookingNotes) {
        setEditedOfficerBookingNotes(editedBookingLocal.officerBookingNotes);
      }
    }
  }, [editedBookingLocal]);
  useEffect(() => {
    if (editedBooking) {
      const item = editedBooking.bookingOrderItems?.find(
        i => i.orderItemType === 0,
      );
      if (item) {
        const filter = {
          accommodationId: item.accommodationId,
          units: item.units,
          adults: item.amountOfAdults,
          childs: item.amountOfChildren,
          includeNonVisible: true,
        } as SelectableAddOnFilter;
        dispatch(getSelectableAddOnsAsync(filter));
      }
      if (
        editedBooking.payerId !== null &&
        editedBooking.payerId !== undefined &&
        editedBooking.payerId !== 'undefined' &&
        editedBooking.payerId !== ''
      ) {
        dispatch(getAcountDetailsFromDbAsync(editedBooking.payerId)).then(
          res => {
            setSelectedPayer(res.payload);
          },
        );
      }
      if (refresh) {
        updateBookingContainer();
      }
      setEditedBookingLocal(editedBooking);
    }
  }, [editedBooking, refresh, dispatch]);

  function selectPayer() {
    if (
      webshopCustomer !== null &&
      webshopCustomer !== undefined &&
      webshopCustomer.lastName != null &&
      (editedBooking.payerId === null || editedBooking.payerId === undefined)
    ) {
      const init = {
        payer: 'pick',
        bookingId: editedBookingLocal.id,
        bookingType: editedBookingLocal.bookingType,
        bookingLocale: editedBookingLocal.invoicingLanguageLocale,
        webshopCustomer,
      };
      history(`/customers/search`, { state: init });
    } else {
      const webshopCustomerCommand = {
        firstName: editedBooking.payerFirstName,
        lastName: editedBooking.payerLastName,
      } as WebShopCustomerItem;
      const init = {
        payer: 'pick',
        bookingId: editedBookingLocal.id,
        webshopCustomer: webshopCustomerCommand,
        bookingLocale: editedBookingLocal.invoicingLanguageLocale,
        bookingType: editedBookingLocal.bookingType,
      };
      history(`/customers/search`, {
        state: init,
      });
    }
  }
  const handleAddCustomerBookingNote = event => {
    const newbookingNote = {
      noteText: '',
    } as CreateBookingNote;
    const newBookingNoteItems = [...editedCustomerBookingNotes, newbookingNote];
    setEditedCustomerBookingNotes(newBookingNoteItems);
  };
  const handleAddOwnerBookingNote = event => {
    const newbookingNote = {
      noteText: '',
    } as CreateBookingNote;
    const newBookingNoteItems = [...editedOwnerBookingNotes, newbookingNote];
    setEditedOwnerBookingNotes(newBookingNoteItems);
  };
  const handleAddOfficerBookingNote = event => {
    const newbookingNote = {
      noteText: '',
    } as CreateBookingNote;
    const newBookingNoteItems = [...editedOfficerBookingNotes, newbookingNote];
    setEditedOfficerBookingNotes(newBookingNoteItems);
  };
  const handleAddToContainer = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const addedItem = editedSelectableAddOns[index];

    // Update the state
    const addAddOnData = {
      bookingId: editedBookingLocal.id,
      accommodationAddOnId: addedItem.id,
      adults: addedItem.amountOfAdults,
      childs: addedItem.amountOfChildren,
      units: addedItem.units,
      grossPrice: addedItem.pricesResponse.grossPrice,
      sitePurchasePrice: addedItem.purchasePricesResponse.sitePurchasePrice,
      arrivalDateTime: getGlobalStartDate(),
      departureDateTime: getGlobalEndDate(),
      bookingContainerId: editedBooking.bookingContainerId,
    } as AddAddOnToBookingContainerItem;
    dispatch(addAddOnToBookingContainerAsync(addAddOnData)).then(res => {
      if (res.payload.isSuccess === true) {
        const findItem = res.payload.result.bookingResponses.filter(
          i => i.id === editedBooking.id,
        );
        if (findItem != null && findItem.length > 0) {
          const newBookingOrderItems = [
            ...editedBookingLocal.bookingOrderItems,
            addedItem,
          ];

          // Create a new copy of editedBooking and update bookingOrderItems
          const newEditedBooking = {
            ...editedBookingLocal,
            bookingOrderItems: newBookingOrderItems,
          };
          localSetEditedBooking(newEditedBooking);
          setEditedBookingLocal(findItem[0]);
          setEditedBooking(findItem[0]);
          dispatch(setBookingContainer(res.payload.result));
        }
      }
    });
  };

  function handleSaveBooking() {
    // saveNewBooking(editedBooking);
    history(`/bookings/${editedBooking.id}`, {
      state: {
        webshopCustomer,
      },
    });
    setShowAdditionalBookingModal(false);
    updateBookingContainer();
  }

  function handleUpdateToPleriminaryBooking() {
    const container = {
      bookingId: editedBooking.id,
    } as UpdateBookingToPreliminary;
    if (editedBookingLocal !== null) {
      dispatch(UpdateBookingToPreliminaryAsync(container)).then(res => {
        if (res.payload.isSuccess === true) {
          const findItem = res.payload.result.bookingResponses.filter(
            i => i.id === editedBooking.id,
          );
          if (findItem != null && findItem.length > 0) {
            setEditedBookingLocal(findItem[0]);
            setEditedBooking(findItem[0]);
            dispatch(setBookingContainer(res.payload.result));
          }
        }
      });
    }
  }

  const handlGrosPriceChange = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];

    // Update the grossPrice of the item at the given index
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      pricesResponse: {
        ...newBookingOrderItems[index].pricesResponse,
        netPrice: Number(value),
      },
    };

    // Create a new copy of editedBooking and update bookingOrderItems
    const newEditedBooking = {
      ...editedBookingLocal,
      bookingOrderItems: newBookingOrderItems,
    };

    // Update the state
    localSetEditedBooking(newEditedBooking);
  };

  const handleSitePurchsePriceChange = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];

    // Update the grossPrice of the item at the given index
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      purchasePricesResponse: {
        ...newBookingOrderItems[index].purchasePricesResponse,
        sitePurchasePrice: Number(value),
      },
    };

    // Create a new copy of editedBooking and update bookingOrderItems
    const newEditedBooking = {
      ...editedBookingLocal,
      bookingOrderItems: newBookingOrderItems,
    };

    // Update the state
    localSetEditedBooking(newEditedBooking);
  };

  const handlTravelPChange = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];

    // Update the grossPrice of the item at the given index
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      pricesResponse: {
        ...newBookingOrderItems[index].pricesResponse,
        travelAgencyComissionP: Number(value),
      },
    };

    // Create a new copy of editedBooking and update bookingOrderItems
    const newEditedBooking = {
      ...editedBookingLocal,
      bookingOrderItems: newBookingOrderItems,
    };

    // Update the state
    localSetEditedBooking(newEditedBooking);
  };

  const handlAdvanceBillPriceChange = event => {
    const { target } = event;
    const { value } = target;
    // Create a new copy of editedBooking and update advanceBillPrice
    if (Number(value) < 0) {
      const newEditedBooking = {
        ...editedBookingLocal,
        advanceBillPrice: 0,
      };

      // Update the state
      localSetEditedBooking(newEditedBooking);
    } else {
      const newEditedBooking = {
        ...editedBookingLocal,
        advanceBillPrice: Number(value),
      };

      // Update the state
      localSetEditedBooking(newEditedBooking);
    }
  };

  const handlDiscountChange = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];

    // Update the grossPrice of the item at the given index
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      pricesResponse: {
        ...newBookingOrderItems[index].pricesResponse,
        discountP: Number(value),
      },
    };

    // Create a new copy of editedBooking and update bookingOrderItems
    const newEditedBooking = {
      ...editedBookingLocal,
      bookingOrderItems: newBookingOrderItems,
    };

    // Update the state
    localSetEditedBooking(newEditedBooking);
  };

  function enumToArray(enumObj: unknown) {
    const keys = Object.keys(enumObj);
    return keys
      .filter(key => Number.isInteger(Number.parseInt(enumObj[key], 10)))
      .map(key => ({ name: key, value: Number.parseInt(enumObj[key], 10) }));
  }
  function getBookingTypeTranslation(
    bookingType: BookingType,
    locale: 'en' | 'fi',
  ): string {
    return bookingTypeTranslations[locale][bookingType] || 'Tuntematon';
  }

  const bookingTypeItems = enumToArray(BookingType).map(item => {
    return {
      value: item.value,
      label: getBookingTypeTranslation(item.value, 'fi'),
    };
  });
  const getAllowedBookingTypes = () => {
    if (editedBooking === null || editedBooking === undefined) {
      return bookingTypeItems;
    }
    if (editedBooking.payerId == null || editedBooking.payerId == null) {
      return bookingTypeItems.filter(
        bt => bt.value === 0 || bt.value === 13 || bt.value === 5,
      );
    }
    if (editedBooking.bookingType === 0) {
      return bookingTypeItems.filter(
        bt =>
          bt.value === 1 ||
          bt.value === 0 ||
          bt.value === 15 ||
          bt.value === 5 ||
          bt.value === 6,
      );
    }
    if (editedBooking.bookingType === 1) {
      return bookingTypeItems.filter(bt => bt.value === 1 || bt.value === 1);
    }
    if (editedBooking.bookingType === 2) {
      return bookingTypeItems.filter(bt => bt.value === 1 || bt.value === 2);
    }
    if (editedBooking.bookingType === 3) {
      return bookingTypeItems.filter(bt => bt.value === 4 || bt.value === 3);
    }
    if (editedBooking.bookingType === 9) {
      return bookingTypeItems.filter(bt => bt.value === 10 || bt.value === 9);
    }
    if (editedBooking.bookingType === 10) {
      return bookingTypeItems.filter(bt => bt.value === 10 || bt.value === 9);
    }
    if (editedBooking.bookingType === 4) {
      return bookingTypeItems.filter(bt => bt.value === 4);
    }
    if (editedBooking.bookingType === 5) {
      return bookingTypeItems.filter(bt => bt.value === 5);
    }
    if (editedBooking.bookingType === 6) {
      return bookingTypeItems.filter(bt => bt.value === 6 || bt.value === 0);
    }
    if (editedBooking.bookingType === 7) {
      return bookingTypeItems.filter(bt => bt.value === 8 || bt.value === 7);
    }
    if (editedBooking.bookingType === 8) {
      return bookingTypeItems.filter(bt => bt.value === 8);
    }
    if (editedBooking.bookingType === 9) {
      return bookingTypeItems.filter(bt => bt.value === 10 || bt.value === 9);
    }
    if (editedBooking.bookingType === 13) {
      return bookingTypeItems.filter(bt => bt.value === 13);
    }
    if (editedBooking.bookingType === 14) {
      return bookingTypeItems.filter(bt => bt.value === 14);
    }
    if (editedBooking.bookingType === 15) {
      return bookingTypeItems.filter(bt => bt.value === 0 || bt.value === 15);
    }
    return bookingTypeItems;
  };
  const billingLocales = enumToArray(BillingLocales).map(item => {
    return { value: item.value, label: item.name };
  });
  const handlUnitsChange = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];

    // Update the grossPrice of the item at the given index
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      units: Number(value),
    };

    // Create a new copy of editedBooking and update bookingOrderItems
    const newEditedBooking = {
      ...editedBookingLocal,
      bookingOrderItems: newBookingOrderItems,
    };

    // Update the state
    localSetEditedBooking(newEditedBooking);
  };
  const handlOfficerCommentChange = event => {
    // Update the state
    const index = Number(event.target.name);
    const newNotes = editedOfficerBookingNotes.map((item, idx) => {
      if (index === idx) {
        return {
          ...item,
          noteText: event.target.value,
        };
      }
      return item;
    });
    setEditedOfficerBookingNotes(newNotes);

    const neweditedBooking = {
      ...editedBookingLocal,
      officerBookingNotes: newNotes,
    };
    setEditedBookingLocal(neweditedBooking);
  };
  const handlOwnerCommentChange = event => {
    // Update the state
    const index = Number(event.target.name);
    const newNotes = editedOwnerBookingNotes.map((item, idx) => {
      if (index === idx) {
        return {
          ...item,
          noteText: event.target.value,
        };
      }
      return item;
    });
    setEditedOwnerBookingNotes(newNotes);

    const neweditedBooking = {
      ...editedBookingLocal,
      ownerBookingNotes: newNotes,
    };
    setEditedBookingLocal(neweditedBooking);
  };

  const handlCustomerCommentChange = event => {
    // Update the state
    const index = Number(event.target.name);
    const newNotes = editedCustomerBookingNotes.map((item, idx) => {
      if (index === idx) {
        return {
          ...item,
          noteText: event.target.value,
        };
      }
      return item;
    });
    setEditedCustomerBookingNotes(newNotes);

    const neweditedBooking = {
      ...editedBookingLocal,
      customerBookingNotes: newNotes,
    };
    setEditedBookingLocal(neweditedBooking);
  };
  const handlUnitsChangeSelectable = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = [...editedSelectableAddOns];

    // Update the grossPrice of the item at the given index
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      units: Number(value),
    };

    // Update the state
    seteditedSelectableAddOns(newBookingOrderItems);
  };

  const handlAdultsChangeRow = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];

    // Update the grossPrice of the item at the given index
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      amountOfAdults: Number(value),
    };
    const newEditedBooking = {
      ...editedBookingLocal,
      bookingOrderItems: newBookingOrderItems,
    };
    setEditedBookingLocal(newEditedBooking);
    seteditedSelectableAddOns(
      editedSelectableAddOns.map((item, indexx) => {
        return {
          ...item,
          amountOfAdults: Number(event.target.value),
        };
      }),
    );
  };
  const handlChildChangeRow = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = [...editedBookingLocal.bookingOrderItems];

    // Update the grossPrice of the item at the given index
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      amountOfChildren: Number(value),
    };
    const newEditedBooking = {
      ...editedBookingLocal,
      bookingOrderItems: newBookingOrderItems,
    };
    setEditedBookingLocal(newEditedBooking);
    seteditedSelectableAddOns(
      editedSelectableAddOns.map((item, indexx) => {
        return {
          ...item,
          amountOfChildren: Number(event.target.value),
        };
      }),
    );
  };

  const handlAdultsChangeSelectable = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = [...editedSelectableAddOns];

    // Update the grossPrice of the item at the given index
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      amountOfAdults: Number(value),
    };

    // Update the state
    seteditedSelectableAddOns(newBookingOrderItems);
  };

  const hanldleChildsChangeSelectable = event => {
    const { target } = event;
    const { value } = target;
    const index = Number(target.name);
    // Create a new copy of bookingOrderItems array
    const newBookingOrderItems = [...editedSelectableAddOns];

    // Update the grossPrice of the item at the given index
    newBookingOrderItems[index] = {
      ...newBookingOrderItems[index],
      amountOfChildren: Number(value),
    };

    // Update the state
    seteditedSelectableAddOns(newBookingOrderItems);
  };

  const handlGrossPriceChangeSelectable = event => {
    // Update the state
    seteditedSelectableAddOns(
      editedSelectableAddOns.map((item, index) => {
        if (index === Number(event.target.name)) {
          return {
            ...item,
            pricesResponse: {
              ...item.pricesResponse,
              grossPrice: Number(event.target.value),
            },
          };
        }
        return item;
      }),
    );
  };

  const handlPurchasePriceChangeSelectable = event => {
    // Update the state
    seteditedSelectableAddOns(
      editedSelectableAddOns.map((item, index) => {
        if (index === Number(event.target.name)) {
          return {
            ...item,
            purchasePricesResponse: {
              ...item.purchasePricesResponse,
              sitePurchasePrice: Number(event.target.value),
            },
          };
        }
        return item;
      }),
    );
  };

  const handlDiscountChangeSelectable = event => {
    // Update the state
    seteditedSelectableAddOns(
      editedSelectableAddOns.map((item, index) => {
        if (index === Number(event.target.name)) {
          return {
            ...item,
            pricesResponse: {
              ...item.pricesResponse,
              discountP: Number(event.target.value),
            },
          };
        }
        return item;
      }),
    );
  };

  const handlTravelCommissionPChangeSelectable = event => {
    // Update the state
    seteditedSelectableAddOns(
      editedSelectableAddOns.map((item, index) => {
        if (index === Number(event.target.name)) {
          return {
            ...item,
            pricesResponse: {
              ...item.pricesResponse,
              travelAgencyComissionP: Number(event.target.value),
            },
          };
        }
        return item;
      }),
    );
  };
  const setRef = (el, index) => {
    textAreaRefs.current[index] = el;
  };
  const setOwnerRef = (el, index) => {
    ownertextAreaRefs.current[index] = el;
  };

  const setOfficerRef = (el, index) => {
    officertextAreaRefs.current[index] = el;
  };
  const generateItemKey = function (Index: number, Text: string) {
    return `${Index.toString()}-${encodeURI(Text.substring(0, 12))}`;
  };
  const location = useLocation();

  const goToBasket = () => {
    history(`/bookings/bookingcontainer/newContainer`, {
      state: {
        container: basketContainer,
        backUrl: `${location.pathname}${location.search}`,
        additional: true,
      },
    });
  };
  const handleSelectChangeBookingType = (selectedOption, name) => {
    if (selectedOption === null) {
      return;
    }
    if (selectedOption.value !== 5) {
      // updateBookingContainer();
      setMakingOwnerBooking(false);
      const tempBookingTypeData2 = {
        ...editedBooking,
        bookingType: selectedOption.value,
      };
      setEditedBookingLocal(tempBookingTypeData2);
      updateBookingContainerWithData(
        tempBookingTypeData2,
        selectedOption.value,
      );
    }
  };
  const selectableAddOnItems = editedSelectableAddOns.map((item, index) => (
    <tr key={item.id}>
      <td>
        {item.addOnNumber !== null && item.addOnNumber > 0
          ? item.addOnNumber
          : ''}{' '}
        {item.accommodationNumber !== undefined && item.accommodationNumber > 0
          ? `${item.accommodationNumber} : `
          : ''}
        {item.itemName !== undefined ? item.itemName : ''}
        {item.amountPerQuantity && '(Määrän mukaan)'}
        {item.amountPerGuest && '(Hlö määrän mukaan)'}
        {item.includedInPrice && (
          <div className="text-danger">Sisältyy hintaan</div>
        )}
      </td>
      <td>
        {getGlobalStartDate() !== ''
          ? new Date(Date.parse(getGlobalStartDate())).toLocaleString('fi-FI', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            })
          : ''}{' '}
        -{' '}
        {getGlobalEndDate() !== ''
          ? new Date(Date.parse(getGlobalEndDate())).toLocaleString('fi-FI', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            })
          : ''}
      </td>
      <td>
        <Form.Control
          size="sm"
          type="number"
          disabled={!item.amountPerQuantity}
          name={index.toString()}
          value={item.units ?? ''}
          onChange={handlUnitsChangeSelectable}
          className="px-8"
        />
      </td>
      <td>
        <Form.Control
          size="sm"
          type="number"
          disabled={item.amountPerGuest !== true}
          name={index.toString()}
          value={item.amountOfAdults ?? ''}
          onChange={handlAdultsChangeSelectable}
          className="px-8"
        />
      </td>
      <td>
        <Form.Control
          size="sm"
          type="number"
          disabled={item.amountPerGuest !== true}
          name={index.toString()}
          value={item.amountOfChildren ?? ''}
          onChange={hanldleChildsChangeSelectable}
          className="px-8"
        />
      </td>
      <td>
        <Form.Control
          size="sm"
          type="number"
          name={index.toString()}
          disabled
          value={item.pricesResponse.grossPrice ?? ''}
          onChange={handlGrossPriceChangeSelectable}
          className="px-8"
        />
      </td>
      <td>
        <Form.Control
          size="sm"
          type="number"
          name={index.toString()}
          disabled
          value={item.purchasePricesResponse.sitePurchasePrice ?? ''}
          onChange={handlPurchasePriceChangeSelectable}
          className="px-8"
        />
      </td>
      <td>
        <Form.Control
          size="sm"
          type="number"
          name={index.toString()}
          disabled
          value={item.pricesResponse.discountP ?? ''}
          onChange={handlDiscountChangeSelectable}
          className="px-8"
        />
      </td>
      <td>
        <Form.Control
          size="sm"
          type="number"
          name={index.toString()}
          disabled
          value={item.pricesResponse.travelAgencyComissionP ?? ''}
          onChange={handlTravelCommissionPChangeSelectable}
          className="px-8"
        />
      </td>
      <td>
        <Button
          size="sm"
          variant="outline-blue"
          name={index.toString()}
          onClick={event => handleAddToBookingContainer(event)}
        >
          Tee lisävaraus
        </Button>
      </td>
    </tr>
  ));
  const bookingOrderItems =
    editedBookingLocal?.bookingOrderItems != null ? (
      editedBookingLocal?.bookingOrderItems
        .filter(oi => oi.orderItemType !== null)
        .map((item, index) => (
          <tr key={item.id}>
            <td>
              {item.addOnNumber !== null && item.addOnNumber > 0
                ? item.addOnNumber
                : ''}{' '}
              {item.accommodationNumber !== undefined &&
              item.accommodationNumber > 0
                ? `${item.accommodationNumber}  `
                : ''}
              {item.itemName !== undefined ? item.itemName : ''}
              {item.includedInPrice && (
                <div style={{ color: 'blue' }}>Sisältyy hintaan</div>
              )}
            </td>
            <td>
              {item.startDateTime !== undefined
                ? new Date(Date.parse(item.startDateTime)).toLocaleString(
                    'fi-FI',
                    {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                      hour: '2-digit',
                      minute: '2-digit',
                    },
                  )
                : ''}{' '}
              -{' '}
              {item.endDateTime !== undefined
                ? new Date(Date.parse(item.endDateTime)).toLocaleString(
                    'fi-FI',
                    {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                      hour: '2-digit',
                      minute: '2-digit',
                    },
                  )
                : ''}
            </td>
            <td>
              <Form.Control
                size="sm"
                type="number"
                disabled
                name={index.toString()}
                value={item.units !== undefined ? item.units : ''}
                onChange={handlUnitsChange}
                className="px-8"
              />
            </td>
            <td>
              <Form.Control
                size="sm"
                type="number"
                disabled
                name={index.toString()}
                value={
                  item.amountOfAdults !== undefined ? item.amountOfAdults : ''
                }
                onChange={handlAdultsChangeRow}
                className="px-8"
              />
            </td>
            <td>
              <Form.Control
                size="sm"
                type="number"
                name={index.toString()}
                disabled
                value={
                  item.amountOfChildren !== undefined
                    ? item.amountOfChildren
                    : ''
                }
                onChange={handlChildChangeRow}
                className="px-8"
              />
            </td>
          </tr>
        ))
    ) : (
      <tr />
    );
  return (
    <Modal
      show={showAdditionalBookingModal}
      onHide={() => handleCloseBooking}
      backdrop="static"
      fullscreen
      keyboard={false}
      size="xl"
    >
      <Modal.Header>
        <div>
          <Modal.Title>
            {'Lisävarauksen luonti, päävaraus: '}
            {editedBookingLocal !== null &&
            editedBookingLocal.bookingNumber === 0
              ? ' Vahvistamaton'
              : editedBookingLocal?.bookingNumber}
          </Modal.Title>
          {editedBooking !== null && editedBooking.bookingType != null && (
            <div className="my-8">
              <span className="fw-bold small">Varauksen tyyppi</span>
              <br />
              {getBookingTypeTranslation(editedBooking.bookingType, 'fi')}
            </div>
          )}
          {editedBooking !== null &&
            (editedBooking.bookingType === 0 ||
              editedBooking.bookingType === 6 ||
              editedBooking.bookingType === 3 ||
              editedBooking.bookingType === 9) && (
              <div>
                <h4>Uusi varaustyyppi: </h4>
                <Select
                  inputId="bookingType"
                  name="bookingType"
                  placeholder="Valitse varaustyyppi"
                  onChange={option =>
                    handleSelectChangeBookingType(option, 'bookingType')
                  }
                  isClearable
                  isSearchable
                  options={getAllowedBookingTypes()}
                  value={bookingTypeItems.filter(
                    option =>
                      option.value ===
                      (editedBookingLocal !== undefined &&
                      editedBookingLocal !== null
                        ? editedBookingLocal.bookingType
                        : 0),
                  )}
                />
              </div>
            )}
          {editedBooking !== null &&
            editedBooking !== null &&
            editedBooking.bookingType === 15 && (
              <Alert variant="primary" className="mt-16">
                Huom!, Luonnostilainen varaus ei varaa kapasiteettia.
                Luonnostilaisen varauksen voi tallentaa vain alustavaksi
                varaukseksi, jolloin kapasiteetti lukittuu.
              </Alert>
            )}
        </div>
      </Modal.Header>
      <Modal.Body className="px-24 py-24 px-lg-40">
        <div className="text-end d-flex flex-column flex-sm-row gap-8 justify-content-end mb-16">
          {basketContainer != null &&
            basketContainer.bookingResponses &&
            basketContainer.bookingResponses.length > 0 && (
              <Button
                size="sm"
                variant="outline-success"
                className="px-16"
                onClick={() => goToBasket()}
              >
                <span className="bg">
                  Mene Koriin(
                  {basketContainer?.bookingResponses?.[0]?.bookingOrderItems
                    ?.length || 0}
                  Lisäpalvelua)
                </span>
              </Button>
            )}
          {editedBooking !== null &&
            editedBooking !== undefined &&
            editedBooking.bookingType === 15 && (
              <Button
                size="sm"
                variant="primary"
                onClick={() => handleUpdateToPleriminaryBooking()}
              >
                Tallenna alustavaksi varaukseksi
              </Button>
            )}
        </div>
        <Heading Level={4} Title="Päävaraus" />
        <div className="table-responsive-lg mb-48">
          <Table className="table-data table-wrap mt-16 mb-32">
            <thead>
              <tr key="header">
                <th key="header-1">Palvelu</th>
                <th key="header-2">Kesto</th>
                <th key="header-3">Määrä</th>
                <th key={Math.random()}>Aikuisia</th>
                <th key={Math.random()}>Lapsia</th>
              </tr>
            </thead>
            <tbody>{bookingOrderItems}</tbody>
          </Table>
          {makingOwnerBooking === false && (
            <div>
              <Heading Level={4} Title="Valittavissa olevat lisäpalvelut" />
              <Table className="table table-data table-wrap mt-16 mb-32">
                <thead>
                  <tr key="headExtra">
                    <th key={Math.random()}>Palvelu</th>
                    <th key={Math.random()}>Kesto</th>
                    <th key={Math.random()}>Määrä</th>
                    <th key={Math.random()}>Aikuisia</th>
                    <th key={Math.random()}>Lapsia</th>
                    <th key={Math.random()}>Hinta/yksikkö</th>
                    <th key={Math.random()}>Ostohinta/yksikkö</th>
                    <th key={Math.random()}>Alennus %</th>
                    <th key={Math.random()}>Matk.Prov.%</th>
                    <th key={Math.random()}>Toiminto</th>
                  </tr>
                </thead>
                <tbody>{selectableAddOnItems}</tbody>
              </Table>
            </div>
          )}
        </div>
        <div>
          {editedBookingLocal !== undefined && editedBookingLocal !== null && (
            <div>
              <Row xs={1} lg={2} className="gx-40 gy-24">
                <Col>
                  {makingOwnerBooking === false && (
                    <div>
                      <div className="d-flex align-items-start mt-48">
                        {selectedPayer !== null && (
                          <h5 className="h5 h-md-4 flex-grow-0 me-16 mb-24">
                            Valittu maksaja
                          </h5>
                        )}
                        <Button
                          variant="outline-blue"
                          onClick={() => selectPayer()}
                          size="sm"
                        >
                          {selectedPayer !== null
                            ? 'Vaihda maksaja'
                            : 'Valitse maksaja'}
                        </Button>
                      </div>
                      {selectedPayer !== null && selectedPayer !== null && (
                        <div>
                          <div>
                            {selectedPayer.firstName} {selectedPayer.lastName}
                          </div>
                          {selectedPayer !== null &&
                            selectedPayer !== null &&
                            selectedPayer.addresses != null &&
                            selectedPayer.addresses.length > 0 && (
                              <div>
                                <div>
                                  {selectedPayer.addresses[0]
                                    .postStreetAddress &&
                                    selectedPayer.addresses[0]
                                      .postStreetAddress}
                                </div>
                                <div>
                                  {selectedPayer.addresses[0].postCode &&
                                    selectedPayer.addresses[0].postCode}{' '}
                                  {selectedPayer.addresses[0].postCity &&
                                    selectedPayer.addresses[0].postCity}
                                </div>
                              </div>
                            )}
                          {selectedPayer !== null &&
                            selectedPayer !== null &&
                            selectedPayer.phones != null && (
                              <div>
                                {selectedPayer.phones[0] !== undefined &&
                                selectedPayer.phones[0] !== null &&
                                selectedPayer.phones[0].phoneNumber
                                  ? selectedPayer.phones[0].phoneNumber
                                  : ''}
                              </div>
                            )}
                        </div>
                      )}
                      {webshopCustomer !== undefined &&
                        webshopCustomer !== null && (
                          <>
                            <h5 className="mt-24">
                              Verkkokaupan asiakastiedot:{' '}
                            </h5>
                            <div>
                              {webshopCustomer.firstName}{' '}
                              {webshopCustomer.lastName}
                            </div>
                            <div>
                              {webshopCustomer.streetAddress}{' '}
                              {webshopCustomer.additionalInformation}
                            </div>
                            <div>
                              {webshopCustomer.postalCode}{' '}
                              {webshopCustomer.postCity}
                            </div>
                            <div>{webshopCustomer.phoneNumber}</div>
                            <div>{webshopCustomer.email}</div>
                          </>
                        )}
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="link" onClick={() => handleCloseBooking()}>
          Sulje
        </Button>
        {editedBookingLocal !== null &&
          editedBookingLocal !== undefined &&
          editedBookingLocal.isAllowedToEdit === true && (
            <Button variant="primary" onClick={() => handleSaveBooking()}>
              Tallenna
            </Button>
          )}
      </Modal.Footer>
    </Modal>
  );
};
